function getPropValue(block, prop) {
  const divs = Array.from(block.querySelectorAll('div'));
  const matchingDiv = divs.find((div) => {
    const text = div.textContent.trim();
    return text.startsWith(`${prop}:`);
  });

  if (matchingDiv) {
    return matchingDiv.textContent.trim().split(':')[1].trim();
  }

  return null;
}

export default getPropValue;
